import { themeColor } from "./_helpers";

export const subTokens = {
  border: themeColor({
    base: "{colors.neutral.200}",
    _themeBlack: "{colors.whiteAlpha.300}",
    _themeWhite: "{colors.neutral.200}",
  }),
  borderHover: themeColor({
    base: "{colors.neutral.400}",
    _themeBlack: "{colors.whiteAlpha.300}",
    _themeWhite: "{colors.neutral.400}",
  }),
  activeBg: themeColor({
    base: "{colors.primary.50}",
    _themeBlack: "{colors.whiteAlpha.200}",
    _themeWhite: "{colors.primary.50}",
  }),
  hoverBg: themeColor({
    base: "{colors.neutral.100}",
    _themeBlack: "{colors.whiteAlpha.100}",
    _themeWhite: "{colors.neutral.100}",
  }),
  activeIndicator: themeColor({
    base: "{colors.primary.600}",
    _themeBlack: "{colors.primary.500}",
    _themeWhite: "{colors.primary.600}",
  }),
  icon: themeColor({
    base: "{colors.neutral.700}",
    _themeBlack: "{colors.neutral.300}",
    _themeWhite: "{colors.neutral.600}",
  }),
};
